<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="disease" class="label">Tipo de enfermedad/plaga</label>
      <angular2-multiselect *ngIf="editionEnabled" [data]=diseases [(ngModel)]="selectedItem"
          [settings]="dropdownSettings"
          (onDeSelect)="OnItemDeSelect($event)"
          (onDeSelectAll)="onDeSelectAll($event)">

        </angular2-multiselect>
        <input *ngIf="!editionEnabled" type="text" nbInput fullWidth id="disease" readonly="true" name="disease" [(ngModel)]="selectedItem[0].name" >
     </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="user" class="label">Reportado por</label>
      <input type="text" nbInput fullWidth id="user" readonly="true" name="user" [(ngModel)]="report.diseaseUser" >
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="fecha" class="label">Fecha de informe</label>
      <input type="text" nbInput fullWidth id="fecha" readonly="true" name="fecha" [(ngModel)]="report.datetime" >
    </div>
  </div>
</div>
<div [hidden]="!report.showLocation" class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="fecha" class="label">Localización</label>
      <div class="geometry-container">
        <button *ngIf="geometryEditable" class="geometry-btn" nbButton size="small" status="primary" (click)="editGeometry()"><nb-icon icon="edit-outline"></nb-icon> Editar</button>
        <div class="panel-body map-container" [attr.id]="config.target" ></div>

      </div>

    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-6">
    <div class="form-group">
      <label for="fecha" class="label">Temperatura</label>
      <input type="text" nbInput fullWidth id="Temperatura" readonly="true" name="Temperatura" [(ngModel)]="report.temperature" >
    </div>
  </div>
  <div class="col-sm-6">
    <div class="form-group">
      <label for="Humedad" class="label">Humedad</label>
      <input type="text" nbInput fullWidth id="Humedad" readonly="true" name="Humedad" [(ngModel)]="report.humidity" >
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="comentarios" class="label">Comentarios</label>
      <textarea nbInput fullWidth id="comentarios" [readOnly]="!editionEnabled" comentarios="fecha" [(ngModel)]="report.comentarios" ></textarea>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="fecha" class="label">Imagen</label>
      <div><img *ngIf="report.imagen" [src]="report.imagen" class="image" (click)="open(report.imagen)"></div>
      <input *ngIf="editionEnabled" type="file" nbInput fullWidth id="diseaseimage" name="desktoplogo" (change)="actualizarImagen($event.target.files)"/>

    </div>
  </div>
</div>

